import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const MovimientoReloj = () => {
  return (
    <div class="listado">
        <h2 className='tituloAccion'>Incorporación Movimiento Reloj</h2>
        <TableContainer>
            <Table sx={{minWidth: 500}} size="small" aria-aria-label='a dense table'>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell><a href=''>Por Ahora Nada</a></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
}

export default MovimientoReloj